import { render, staticRenderFns } from "./BaseFormCombo.vue?vue&type=template&id=00c72cb9&scoped=true"
import script from "./BaseFormCombo.vue?vue&type=script&lang=js"
export * from "./BaseFormCombo.vue?vue&type=script&lang=js"
import style0 from "./BaseFormCombo.vue?vue&type=style&index=0&id=00c72cb9&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c72cb9",
  null
  
)

export default component.exports